import { createFileRoute } from "@tanstack/react-router"
import ResetPassword from "@/pages/account/reset-password"

type ResetPasswordSearch = {
  token?: string
}

export const Route = createFileRoute("/$countryCode/account/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Reset password | +Bake Cafe" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ResetPassword,
})
